<template>
  <div class="historial-horas">
    <b-card>
      <div class="tabla-wrapper">
        <table class="tabla-resumen">
          <thead>
            <tr>
              <th class="sticky-col">Categoria</th>
              <th class="sticky-col">Equipo</th>

              <th v-for="hora in horas" :key="hora">
                {{ hora }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="equipo in equipos" :key="equipo.id_equipo">
              <td class="sticky-col nombre-equipo">
                {{ equipo.categoria }}
              </td>
              <td class="sticky-col nombre-equipo">
                {{ equipo.equipo }}
              </td>

              <td
                v-for="hora in horas"
                :key="hora"
                :style="getColor(equipo.horas[hora])"
              >
                {{ equipo.horas[hora] || 0 }}
              </td>
            </tr>

            <tr v-if="!equipos || equipos.length === 0">
              <td :colspan="horas.length + 1" class="empty">
                No hay datos disponibles
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { BCard } from 'bootstrap-vue'

export default {
  components: {
    BCard,
  },

  props: {
    equipos: {
      type: Array,
      default: () => [],
    },
    horas: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    // 🔥 max dinámico igual que el otro componente
    const maxValor = computed(() => {
      if (!props.equipos?.length) return 1

      return Math.max(
        ...props.equipos.flatMap(
          e =>
            // eslint-disable-next-line
            props.horas.map(h => Number(e.horas?.[h]) || 0),
          // eslint-disable-next-line
        ),
      )
    })

    // 🎨 heatmap dinámico
    const getColor = valor => {
      const v = Number(valor) || 0

      if (v === 0) return 'background-color: #f5f5f5'

      const ratio = v / maxValor.value

      const lightness = 90 - ratio * 50
      const color = `hsl(200, 70%, ${lightness}%)` // 🔵 azul para diferenciar del verde

      return `background-color: ${color}; color: ${
        ratio > 0.6 ? 'white' : 'black'
      }`
    }

    return {
      getColor,
    }
  },
}
</script>

<style scoped>
.historial-horas {
  margin: 10px;
  font-family: Arial, sans-serif;
}

.tabla-wrapper {
  height: calc(100vh - 300px);
  overflow: auto;
  border: 1px solid #ddd;
  border-radius: 10px;
}

.tabla-resumen {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

.tabla-resumen th,
.tabla-resumen td {
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

/* HEADER STICKY */
.tabla-resumen thead th {
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 3;
  font-weight: bold;
}

/* COLUMNA STICKY */
.sticky-col {
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 2;
  text-align: left;
}

/* estilos */
.nombre-equipo {
  font-weight: 600;
  font-size: 12px;
}

/* empty */
.empty {
  padding: 20px;
  text-align: center;
  color: #999;
}
</style>
